export const config = {
  title: "Nolan Bremseth | Keller Williams Classic Realty | Minneapolis, MN",
  meta: {
    description:
      "Nolan Bremseth is your trusted real estate professional with Keller Williams Classic Realty in Minneapolis, MN. Expert guidance for buying and selling homes in the Twin Cities, Coon Rapids, Anoka County, and surrounding areas.",
    keywords: [
      "Nolan Bremseth Realtor",
      "Keller Williams Minneapolis",
      "Minneapolis Real Estate",
      "Twin Cities Homes for Sale",
      "Coon Rapids Realtor",
      "Anoka County Real Estate",
      "Minnesota Real Estate Agent",
      "Buy Home Minneapolis MN"
    ],
    author: "Nolan Bremseth",
    canonicalUrl: "https://www.kellerwilliamsnolan.com/",
  },
  sections: {
    header: {
      businessName: "Nolan Bremseth",
      tagline: "Keller Williams Classic Realty",
    },
    sectionB: {
      heroTitle: "Your Trusted Real Estate Partner in the Twin Cities",
      heroSubtitle: "Expert Real Estate Services Throughout Minneapolis & Anoka County",
      learnAboutText: "Start Your Home Search",
      phoneNumber: "5076968257",
      phoneLabel: "(507) 696-8257",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80",
      cardData: [
        {
          title: "Home Buying",
          description:
            "Find your perfect home in the Twin Cities with expert guidance through every step.",
        },
        {
          title: "Home Selling",
          description:
            "Maximize your property value with strategic marketing and professional representation.",
        },
        {
          title: "Local Expertise",
          description:
            "Deep knowledge of Minneapolis, Coon Rapids, and Anoka County neighborhoods.",
        },
      ],
      description:
        "Nolan Bremseth is a dedicated real estate professional with Keller Williams Classic Realty, proudly serving Minneapolis, Coon Rapids, Anoka County, and the greater Twin Cities area. Whether you're buying your first home or selling your property, experience personalized service backed by industry-leading resources.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "Comprehensive real estate solutions for the Twin Cities metro area. From first-time homebuyers to seasoned investors, I provide the expertise and dedication you need to succeed in today's market.",
      cards: [
        {
          title: "Buyer Representation",
          description:
            "Expert guidance through the entire home buying journey. Access to exclusive listings, neighborhood insights, and negotiation expertise to secure your dream home.",
          imageSrc: "https://media.istockphoto.com/id/2174014921/photo/real-estate-agent-giving-a-man-the-keys-to-his-new-home.jpg?s=612x612&w=0&k=20&c=WBuChYqnWW17g4S2sXOcKdJUJi6GHW5YZ_IJaO5Wu0Y=",
          imageAlt: "Beautiful Minnesota home",
        },
        {
          title: "Seller Services",
          description:
            "Strategic marketing, professional photography, and expert pricing strategies to sell your home quickly and for top dollar in the competitive Twin Cities market.",
          imageSrc: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=600&q=80",
          imageAlt: "Home for sale",
        },
        {
          title: "Market Analysis",
          description:
            "Comprehensive market insights and property valuations for Minneapolis and Anoka County. Stay informed with current trends and accurate home values.",
          imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80",
          imageAlt: "Market analysis and data",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "First-Time Homebuyer Programs",
        "Investment Property Guidance",
        "Relocation Services",
        "New Construction Representation",
        "Property Management Referrals",
        "Home Valuation & CMA",
      ],
    },
    sectionD: {
      aboutTitle: "About Nolan Bremseth",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/00/2405900_normal.jpg",
        alt: "Nolan Bremseth Real Estate Professional",
      },
      aboutText: [
        "Nolan Bremseth is a passionate real estate professional serving the Minneapolis and Anoka County area with Keller Williams Classic Realty. With a commitment to excellence and client-focused service, Nolan helps buyers and sellers navigate the Twin Cities real estate market with confidence.",
        "As part of Keller Williams Classic Realty, the #1 real estate brokerage in Anoka County, Nolan combines local market expertise with cutting-edge technology and world-class training. This powerful combination ensures exceptional results whether you're buying your first home, upgrading to your dream property, or selling for maximum value.",
        "Nolan's approach centers on building lasting relationships through honest communication, market knowledge, and dedicated service. Whether you're exploring neighborhoods in Minneapolis, Coon Rapids, Maple Grove, or anywhere in the Twin Cities metro, Nolan is committed to making your real estate goals a reality.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Nolan Bremseth - Keller Williams Realtor",
      businessName: "Nolan Bremseth",
      subtitle: "Keller Williams Classic Realty",
      contact: {
        phone: "5076968257",
        phoneLabel: "(507) 696-8257",
        email: "nolanbremseth@kw.com",
        website: "https://www.kellerwilliamsnolan.com/",
        address: "1740 116th Ave NW #100, Minneapolis, MN 55448",
      },
      socialMedia: {
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
      },
    },
    sectionF: {
      address: "1740 116th Ave NW #100, Minneapolis, MN 55448",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2816.234!2d-93.3567!3d45.1789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52b333909377bbbb%3A0x1234567890abcdef!2s1740%20116th%20Ave%20NW%20%23100%2C%20Minneapolis%2C%20MN%2055448!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;